export const EN_TRANSLATION = {
}
